import { toast } from 'react-toastify'
import { ExportStatus } from '@archax/shared-types'
import { getExportById } from '../api/exports'

let pollingInterval: any
const listeners = [] as { id: string; fileName: string; title: string }[]

async function fetchExports() {
  if (!listeners.length) {
    clearInterval(pollingInterval)
    pollingInterval = null
    return
  }

  for (const instance of listeners) {
    const { data: exportInstance } = await getExportById(instance.id)
    if (exportInstance.status !== ExportStatus.Pending) {
      if (exportInstance.status === ExportStatus.Ready) {
        toast.success(`${instance.title} ${instance.fileName} is ready for download`)
      } else if (exportInstance.status === ExportStatus.Failed) {
        toast.error(
          `Export failed. We couldn't generate the ${instance.title.toLowerCase()} file. Please contact support if the issue persists.`,
        )
      }

      const index = listeners.findIndex((it) => it.id === instance.id)
      if (index >= 0) {
        listeners.splice(index, 1)
      }
    }
  }
}

export function register(instance: { id: string; fileName: string; title: string }) {
  if (!pollingInterval) {
    pollingInterval = setInterval(fetchExports, 1000)
  }
  listeners.push(instance)
}
